import React from 'react';
import PropTypes from 'prop-types';
import UiComponent from '../UiComponent';

export default class MultiSelect extends UiComponent {
  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);
    this.buildOptions = this.buildOptions.bind(this);
    this.getSource = this.getSource.bind(this);
    this.hasDublicate = this.hasDublicate.bind(this);
    this.findIndexObjectInArray = this.findIndexObjectInArray.bind(this);
  }

  getSource() {
    if (this.props.field && this.props.field.source) {
      return this.props.field.source;
    } else {
      return this.props.options;
    }
  }

  componentDidUpdate(prevProps, prevState) {
    this.props.field.value = this.props.options;
  }

  buildOptions() {
    const arrOptions = [];
    const source = this.getSource();
    for (let i = 0; i < source.length; i++) {
      const currentOption = source[i];
      const checked = currentOption.checked;
      arrOptions.push(
        <div key={i} value={currentOption.value}>
          <label className="custom-control custom-checkbox">
            <input
              type="checkbox"
              className="custom-control-input"
              onChange={(e) => { this.changeValue(currentOption); }}
              checked={checked}
              disabled={this.props.disabled}
            />
            <span className="custom-control-indicator" />
            <span
              className="custom-control-description"
            >
              {currentOption.label}
            </span>
          </label>
        </div>
      );
    }
    return arrOptions;
  }

  hasDublicate(value) {
    if (value && Array.isArray(this.props.field.value) && (this.findIndexObjectInArray(this.props.field.value, value) !== -1)) {
      return false;
    } else {
      return true;
    }
  }

  findIndexObjectInArray(arr, value) {
    const arrNames = arr.map(function(item){
      return item.value;
    });

    return arrNames.indexOf(value.value);
  }

  updateValue(value) {
    const index = this.findIndexObjectInArray(this.props.field.value, value);
    this.props.field.value[index].checked = !this.props.field.value[index].checked;
    return this.props.field;
  }

  changeValue(value) {
    const hasDublicate = this.hasDublicate(value);
    if(!hasDublicate){
      const field = this.updateValue(value);
      this.props.onChange(field.name, field);
    }
  }

  render() {
    return (
      <div className="form-group">
        {this.getLabel()}
        <div className="milti-select col-12">
          {this.buildOptions()}
        </div>
        {this.getErrors()}
      </div>
    );
  }
}

MultiSelect.propTypes = {
  options: PropTypes.array,
  field: PropTypes.object,
  disabled: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/common/MultiSelect/index.js